import { PaymentIntent, StripePaymentInformation } from '../../types';
import { useEffect, useState } from 'react';
import { createPaymentIntent } from '../../network';

export const useCreatePaymentIntent = (paymentInformation: StripePaymentInformation) => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [amount, setAmount] = useState<number>(0);
  const [currency, setCurrency] = useState<string>('eur');
  const [loadingClientSecret, setLoadingClientSecret] = useState(false);
  const [paymentError, setPaymentError] = useState<string | null>(null);

  useEffect(() => {
    setLoadingClientSecret(true);
    createPaymentIntent(paymentInformation)
      .then((data: PaymentIntent) => {
        setClientSecret(data.client_secret);
        setCurrency(data.currency);
        setAmount(data.amount);
      })
      .catch(e => {
        setPaymentError(JSON.parse(e.message)['hydra:description']);
      })
      .finally(() => {
        setLoadingClientSecret(false);
      });
    setLoadingClientSecret(false);
  }, [paymentInformation]);

  return { clientSecret, amount, currency, loadingClientSecret, paymentError };
};
